/**
 * "Chrome · Windows" a partir do User-Agent. Não precisa ser perfeito: serve para o
 * admin ver que a mesma conta apareceu num aparelho diferente do de sempre.
 */
export const descreverAparelho = (ua?: string | null): string => {
  if (!ua) return "Aparelho desconhecido";

  const navegador =
    /Edg\//.test(ua) ? "Edge"
    : /OPR\/|Opera/.test(ua) ? "Opera"
    : /SamsungBrowser/.test(ua) ? "Samsung Internet"
    : /Firefox\//.test(ua) ? "Firefox"
    : /Chrome\/|CriOS\//.test(ua) ? "Chrome"
    : /Safari\//.test(ua) ? "Safari"
    : /okhttp|curl|python|java/i.test(ua) ? "Script"
    : "Navegador";

  const sistema =
    /iPhone/.test(ua) ? "iPhone"
    : /iPad/.test(ua) ? "iPad"
    : /Android/.test(ua) ? "Android"
    : /Windows/.test(ua) ? "Windows"
    : /Mac OS X|Macintosh/.test(ua) ? "Mac"
    : /Linux/.test(ua) ? "Linux"
    : "";

  return sistema ? `${navegador} · ${sistema}` : navegador;
};
